import { render, staticRenderFns } from "./ContactsGroupDetailsView.vue?vue&type=template&id=16008b0e&"
import script from "./ContactsGroupDetailsView.vue?vue&type=script&lang=js&"
export * from "./ContactsGroupDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports